import { PayloadAction } from '@reduxjs/toolkit';
import { AnnotationsState } from '@reducers/v2/annotationsV2/annotationsV2.slice';

export const removeAnnotationAction = (
  state: AnnotationsState,
  action: PayloadAction<{ documentId: number; pageNumber: number; annotationId: string }>
) => {
  const { documentId, pageNumber, annotationId } = action.payload;
  const pageAnnotations = state.byDocument[documentId]?.[pageNumber];
  if (!pageAnnotations) {
    return;
  }
  state.byDocument[documentId][pageNumber] = pageAnnotations.filter((a) => a.id !== annotationId);
};
